import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "productSpecsElementForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.productSpecsElement.relations.productSpecs,
                  label: "Product Specs",
                  multiple: false,
                  "item-text": "product",
                  "item-value": "id",
                  chips: "",
                  "deletable-chips": "",
                },
                model: {
                  value: _vm.productSpecsElement.productSpecs,
                  callback: function ($$v) {
                    _vm.$set(_vm.productSpecsElement, "productSpecs", $$v)
                  },
                  expression: "productSpecsElement.productSpecs",
                },
              }),
              _c(VSelect, {
                attrs: {
                  items: _vm.productSpecsElement.relations.element,
                  label: "Element",
                  multiple: false,
                  "item-text": "element_name",
                  "item-value": "id",
                  chips: "",
                  "deletable-chips": "",
                },
                model: {
                  value: _vm.productSpecsElement.element,
                  callback: function ($$v) {
                    _vm.$set(_vm.productSpecsElement, "element", $$v)
                  },
                  expression: "productSpecsElement.element",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Min Percent", required: false },
                model: {
                  value: _vm.productSpecsElement.minPercent,
                  callback: function ($$v) {
                    _vm.$set(_vm.productSpecsElement, "minPercent", $$v)
                  },
                  expression: "productSpecsElement.minPercent",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Max Percent", required: false },
                model: {
                  value: _vm.productSpecsElement.maxPercent,
                  callback: function ($$v) {
                    _vm.$set(_vm.productSpecsElement, "maxPercent", $$v)
                  },
                  expression: "productSpecsElement.maxPercent",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }